import React, { useState, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../store/hooks";
import { forgotPassword, clearError } from "../store/authSlice";

import "@fortawesome/fontawesome-free/css/all.min.css";

interface ForgotPasswordFormProps {
  onBackToLogin?: () => void;
  onShowResetForm?: () => void;
}

const ForgotPasswordForm: React.FC<ForgotPasswordFormProps> = ({
  onBackToLogin,
}) => {
  const dispatch = useAppDispatch();
  const { isLoading, error } = useAppSelector((state) => state.auth);
  const [email, setEmail] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);
  const isButtonDisabled = !email;

  useEffect(() => {
    dispatch(clearError());
  }, [dispatch]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    try {
      await dispatch(forgotPassword(email)).unwrap();
      setIsSuccess(true);
    } catch (error) {
      console.error('Forgot password failed:', error);
    }
  };

  const handleBackToLogin = () => {
    if (onBackToLogin) {
      onBackToLogin();
    }
  };

  return (
    <div className="flex justify-center items-center login-form-width">
      <div className="w-[444px] p-6 rounded-2xl border border-lighterGray login-box-shadow h-fit">
        <h2 className="text-h1 font-bold text-darkestSlate pb-2">
          Forgot Password?
        </h2>
        <button
          type="button"
          className="text-h3 font-semibold text-darkBlue hover:underline mb-6 text-start"
          onClick={handleBackToLogin}
        >
          Return to Log In
        </button>
        {!isSuccess ? (
          <form className="flex flex-col" onSubmit={handleSubmit}>
            <label
              htmlFor="form-mail"
              className="text-h4 font-medium text-darkGray pb-1"
            >
              Email *
            </label>
            <input
              type="email"
              name="email"
              placeholder="Email"
              id="form-mail"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                if (error) {
                  dispatch(clearError());
                }
                if (isSuccess) {
                  setIsSuccess(false);
                }
              }}
              className={`h-10 px-3 py-2.5 mb-1 rounded-xl bg-lightestGray border ${
                error ? "border-red-500" : "border-lighterGray"
              }`}
            />
            {error && <p className="text-red-500 text-sm mb-4">{error}</p>}
            <button
              type="submit"
              className={`text-h3 mt-6 font-semibold text-lightestGray h-10 rounded-3xl flex items-center justify-center gap-2 hover:bg-mediumGray ${
                isButtonDisabled || isLoading ? "bg-gray cursor-not-allowed" : "bg-darkBlue"
              }`}
              disabled={isButtonDisabled || isLoading}
            >
              {isLoading ? "Sending..." : "Send Code to Email"}
              {!isLoading && <i className="fas fa-arrow-right"></i>}
            </button>
          </form>
        ) : (
          <div className="flex flex-col">
            <p className="text-green-600 text-sm mb-4">
              If your email is on file, a password reset email should be in your inbox shortly.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ForgotPasswordForm;
